// extracted by mini-css-extract-plugin
export var gif = "_kp-0";